import { FiCreditCard, FiTruck } from "react-icons/fi";
import { formatNgn } from "../libs/orderDisplayUtils";

const PaymentMethodSelector = ({
  paymentMethod,
  onChange,
  shippingMethod,
  podEligible,
  podEnabled,
  podBlockedMessage,
  podMaxAmount,
  podBlockDays = 60,
  orderTotal,
  isLoggedIn,
}) => {
  const podAvailable =
    podEnabled && podEligible && shippingMethod === "door" && isLoggedIn;
  const overPodLimit =
    podMaxAmount != null && orderTotal != null && orderTotal > podMaxAmount;

  return (
    <div className="payment-method-group">
      <h4>Payment method</h4>
      <div className="payment-method-cards">
        <button
          type="button"
          className={`payment-method-card${
            paymentMethod === "paystack" ? " payment-method-card--active" : ""
          }`}
          onClick={() => onChange("paystack")}
        >
          <span className="payment-method-card__icon payment-method-card__icon--online">
            <FiCreditCard />
          </span>
          <span className="payment-method-card__body">
            <strong>Pay online</strong>
            <small>Card or bank transfer via Paystack</small>
          </span>
        </button>

        <button
          type="button"
          className={`payment-method-card${
            paymentMethod === "pay_on_delivery"
              ? " payment-method-card--active"
              : ""
          }${!podAvailable || overPodLimit ? " payment-method-card--disabled" : ""}`}
          onClick={() => {
            if (podAvailable && !overPodLimit) onChange("pay_on_delivery");
          }}
          disabled={!podAvailable || overPodLimit}
        >
          <span className="payment-method-card__icon payment-method-card__icon--pod">
            <FiTruck />
          </span>
          <span className="payment-method-card__body">
            <strong>Pay on delivery</strong>
            <small>
              {!isLoggedIn
                ? "Sign in required"
                : !podEnabled
                  ? "Currently unavailable"
                  : overPodLimit && podMaxAmount
                    ? `Up to ${formatNgn(podMaxAmount)}`
                    : "Pay cash when your order arrives"}
            </small>
          </span>
        </button>
      </div>

      {isLoggedIn && shippingMethod === "pickup" && (
        <p className="checkout-note checkout-note--muted">
          Pay on delivery requires door delivery.
        </p>
      )}

      {isLoggedIn && !podEnabled && (
        <p className="checkout-note checkout-note--muted">
          Pay on delivery is turned off by the marketplace admin.
        </p>
      )}

      {podBlockedMessage && (
        <p className="checkout-note checkout-note--warning" role="alert">
          {podBlockedMessage}
        </p>
      )}

      {paymentMethod === "pay_on_delivery" && orderTotal != null && (
        <p className="checkout-note checkout-note--pod-total">
          Amount due at delivery: <strong>{formatNgn(orderTotal)}</strong>
        </p>
      )}

      {paymentMethod === "pay_on_delivery" && (
        <p className="checkout-tracking-note">
          Have the exact amount ready at delivery. Refusing to accept or pay suspends
          pay-on-delivery for {podBlockDays} days.
        </p>
      )}
    </div>
  );
};

export default PaymentMethodSelector;
